import {CreateSessionActions, CreateSessionState, CreateSessionSteps} from "./types";

export const initialCreateSessionState: CreateSessionState = {
  currentCreateSessionStep: "basicForm",
  formData: {
    bookingQuestions: [],
    callDuration: "15",
    callLocation: "video",
    callPrice: 100,
    callPriceCurrency: "NGN",
    callPriceType: "paid",
    currencies: [],
    customCallDuration: undefined,
    description: "",
    hideFromProfile: false,
    // isPaused: false,
    isUrlRedirect: false,
    redirectAfterPurchase: "none",
    telegramGroupId: undefined,
    name: "",
    requestCustomerPhoneNumber: false,
    slug: "",
    url_redirect: undefined,
    coverImage: null,
    availabilityScheduleId: "",
  },
  sessionData: null,
};

export const createSessionReducer = (
  state: CreateSessionState = initialCreateSessionState,
  action: CreateSessionActions
) => {
  if (action.type === "update-create-session-form-step") {
    const yo = {...state, currentCreateSessionStep: action.payload};
    return yo;
  }
  if (action.type === "go-to-basic-form-step") {
    const yo = {
      ...state,
      currentCreateSessionStep: "basicForm" as CreateSessionSteps,
      formData: {
        ...state.formData,
        ...action.payload,
      },
    };
    return yo;
  }
  if (action.type === "go-to-checkout-form-step") {
    const yo = {
      ...state,
      currentCreateSessionStep: "checkoutForm" as CreateSessionSteps,
      formData: {
        ...state.formData,
        ...action.payload,
      },
    };
    return yo;
  }

  if (action.type === "go-to-cover-images-upload-form-step") {
    const yo = {
      ...state,
      currentCreateSessionStep: "coverImagesUpload" as CreateSessionSteps,
      formData: {
        ...state.formData,
        ...action.payload.formData,
      },
      sessionData: action.payload.session,
    };
    return yo;
  }
  if (action.type === "save-create-session-form-values") {
    return {
      ...state,
      formData: {
        ...state.formData,
        ...action.payload,
      },
    };
  }
  if (action.type === "reset-state") {
    const yo = {...initialCreateSessionState};
    return yo;
  }

  return state;
};
